export default class mobileSlider {
    /*
    * WIP - Code to improve
    * Switch slick slider only in mobile 
    */
    constructor() {
        this.intSlider()
        this.addEvents();
    }


    addEvents(){
        /*
        * On resize event, check docuemnt size and initialize slick slider if is in mobile
        */ 
        let _this = this;
        $(window).resize(function() {
            if( $( document ).width() < 1024 ){ 
                _this.intSlider()
            }
        });
    }

    /*
    * Initialize slick slider
    */ 
    intSlider(){
        $('.js-mobile-slider').slick({
            autoplay: false,
            autoplaySpeed: 4500,
            infinite: false,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: 'unslick',
                }, 
                {
					breakpoint: 1024,
					settings: { 
                        dots: true, 
                        slidesToShow: 1,
                        slidesToScroll: 1,
					},
				},
			],
        });
    }
 

}